import { useMemo } from "react";
import { shuffleArray } from '../utils/arrayUtils';
import { COLORS } from "../constants/colors";

const aleaColors = shuffleArray(COLORS);

/**
 * Associe chaque clé à une couleur.
 * - La première clé prend la première couleur, sans incrément.
 * - Ensuite, on avance dans la palette seulement si la clé ne contient pas "_".
 * - Si on dépasse la longueur de la palette, on recommence au début (cycle).
 */
export function useColorMapping(keys) {
    return useMemo(() => {
        
        let colorIndex = 0;
        const mapping = {};

        keys.sort().forEach((key, idx) => {
            // ⚡️ Incrément seulement si :
            // - ce n’est pas la première clé
            // - et la clé ne contient pas "_"
            if (idx > 0 && !key.includes("_")) {
                colorIndex++;
            }
            mapping[key] = aleaColors[colorIndex % COLORS.length];
            
            // console.log(idx, key, colorIndex);
        });

        return mapping;
    }, [keys]);
}
